import { CONFIRM_DIALOG, PRINTER_DIALOG } from '../../../../redux/constants/dialogs';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent';
import styles from '../PrintersView/styles';
import PrintIcon from '@material-ui/icons/Print';
import React from 'react';
import Grid from '../../../Common/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

const COLUMNS = [
  { name: 'name', title: 'Name' },
  { name: 'type', title: 'Type' },
  { name: 'connection', title: 'Connection' },
  { name: 'ip', title: 'IP' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'action', width: 150 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    default :
      return value;
  }
};

class PrintersGrid extends React.Component {

  handleAdd = () => {
    this.handleEdit({});
  };

  handleEdit = (printer) => {
    this.props.showDialog(PRINTER_DIALOG, { printer });
  };

  handleRemove = (printer) => {
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to remove this printer?',
        onConfirm: () => {
          this.props.onRemove(printer).then(resolve);
        },
        onReject: reject,
        confirmColor: 'secondary',
      });
    });
  };

  render() {
    const { data, fetch } = this.props;

    const buttons = [<Tooltip key="create" title="Add Customer">
      <Fab
        color="secondary"
        aria-label="add"
        style={styles.add}
        onClick={this.handleAdd}
        id="addPrinter"
      >
        <AddIcon/>
      </Fab>
    </Tooltip>];

    return (<Grid
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent}
      buttons={buttons}
      data={data}
      fetch={fetch}
      noDataCellComponent={getNoDataCellComponent(<PrintIcon style={styles.noData}/>, 'printers')}
      onEdit={this.handleEdit}
      onRemove={this.handleRemove}
    />);

  }

}

export default PrintersGrid;



// WEBPACK FOOTER //
// ./src/components/Admin/Printers/PrintersGrid/index.js